module.exports = __webpack_public_path__ + "static/media/eixarch2.f7f4b559.jpg";